export const genderOptions = [
  {
    label: 'Male',
    value: 'MALE',
  },
  {
    label: 'Female',
    value: 'FEMALE',
  },
  {
    label: 'NOT_SPECIFIED',
    value: 'NOT_SPECIFIED',
  },
];
export const visaOptions = [
  {
    label: 'H-1B',
    value: 'H-1B',
  },
  {
    label: 'Green Card',
    value: 'Green Card',
  },
  {
    label: 'Green Card EAD',
    value: 'Green Card EAD',
  },
  {
    label: 'E3',
    value: 'E3',
  },
  {
    label: 'Citizen',
    value: 'Citizen',
  },
  {
    label: 'OPT',
    value: 'OPT',
  },
  {
    label: 'CPT',
    value: 'CPT',
  },
  {
    label: 'L2-EAD',
    value: 'L2-EAD',
  },
  {
    label: 'TN-VISA',
    value: 'TN-VISA',
  },
  {
    label: 'H4-EAD',
    value: 'H4-EAD',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'NA',
    value: 'NA',
  },
];

export const nationalityOptions = [
  {
    label: 'Indian',
    value: 'India',
  },
  {
    label: 'American',
    value: 'American',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'NA',
    value: 'NA',
  },
];
export const commonOptions = [
  {
    label: 'Yes',
    value: 'YES',
  },
  {
    label: 'No',
    value: 'NO',
  },
  {
    label: 'None',
    value: 'NONE',
  },
  {
    label: 'NA',
    value: 'NA',
  },
];
export const jobTypeOptions = [
  {
    label: 'NA',
    value: 'NA',
  },
  {
    label: 'Permanent',
    value: 'Permanent',
  },
  {
    label: 'Contract',
    value: 'Contract',
  },
  {
    label: 'Temporary',
    value: 'Temporary',
  },
  {
    label: 'FullType',
    value: 'FullType',
  },
  {
    label: 'Internship',
    value: 'Internship',
  },
  {
    label: 'None',
    value: 'None',
  },
  {
    label: 'ContractToHireW2',
    value: 'ContractToHireW2',
  },
  {
    label: 'ContractW2',
    value: 'ContractW2',
  },
  {
    label: 'ContractIndependent',
    value: 'ContractIndependent',
  },
  {
    label: 'ContractToHireIndependent',
    value: 'ContractToHireIndependent',
  },
  {
    label: 'ContractCorpToCorp',
    value: 'ContractCorpToCorp',
  },
  {
    label: 'ContractToHireCorpToCorp',
    value: 'ContractToHireCorpToCorp',
  },
  {
    label: 'PartTime',
    value: 'PartTime',
  },
  {
    label: 'Freelance',
    value: 'Freelance',
  },
  {
    label: 'PermanentAndContract',
    value: 'PermanentAndContract',
  },
  {
    label: 'ThirdParty',
    value: 'ThirdParty',
  },
];
export const communicationOptions = [
  {
    label: 'Email',
    value: 'Email',
  },
  {
    label: 'Phone',
    value: 'Phone',
  },
  {
    label: 'Email & Phone',
    value: 'Email & Phone',
  },
  {
    label: 'NA',
    value: 'NA',
  },
];
export const sourceOptions = [
  {
    label: 'Monster',
    value: 'Monster',
  },
  {
    label: 'Dice',
    value: 'Dice',
  },
  {
    label: 'TechFetch',
    value: 'TechFetch',
  },
  {
    label: 'CareerBuilder',
    value: 'CareerBuilder',
  },
  {
    label: 'CWJobs',
    value: 'CWJobs',
  },
  {
    label: 'NA',
    value: 'NA',
  },
];

export const copyStringToClipboard = (data: string) => {
  function handler(event) {
    event.clipboardData.setData('text/plain', data);
    event.preventDefault();
    document.removeEventListener('copy', handler, true);
  }
  document.addEventListener('copy', handler, true);
  document.execCommand('copy');
};

export const jobPreferrenceType = [
  {
    label: 'Contract',
    value: 'Contract',
  },
  {
    label: 'Permanent',
    value: 'Permanent',
  },
  {
    label: 'Contract & Permanent',
    value: 'Contract & Permanent',
  },
  {
    label: 'NA',
    value: 'NA',
  },
];

export const noticePeriodOptions = [
  { label: 'Immediately', value: 'Immediate' },
  { label: '15 Days', value: 'Within_15_Days' },
  { label: '1 month', value: 'Within_1_Month' },
  { label: '2 months', value: 'Within_2_Months' },
  { label: '3 months', value: 'Within_3_Months' },
  { label: '4 months', value: 'Within_4_Months' },
  { label: 'None', value: 'None' },
];
